import clsx from 'clsx'
import React, {useContext} from 'react'
import {makeStyles} from 'external/material'

import {faUsers} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"

import {TeacherContext} from 'teacher/context'
import SelectStudent from './select-student'

const useStyles = makeStyles(filterStyles)

export default function StudentGradesFilters() {

  const classes = useStyles()
  const context = useContext(TeacherContext)
  const {link, groupId, groups} = context
  const path = link({page: 'gradebook', groupId})
  const group = groups.find(g => g.id == groupId) || {}

  return (
    <div className={classes.root}>
      <div className={clsx(classes.groupContainer, classes.middle)}>
        <div className={classes.group}>
          <span className={classes.groupIcon}>
          <FontAwesomeIcon icon={faUsers} />
          </span>
          <span className={classes.groupName}>{group.name}</span>
        </div>
      </div>
      <div className={clsx(classes.studentContainer, classes.middle)}>
        {group.id && (<SelectStudent group={group} />)}
      </div>
    </div>
  )
}

function filterStyles() {
  return {
    root: {
      display: "flex",
      marginBottom: 10
    },
    middle: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center'
    },
    group: {
      display: 'flex',
      marginRight: 25
    },
    groupName: {
      fontSize: '11pt',
      fontWeight: 'bold',
      color: '#4f576e',
    },
    groupIcon: {
      marginRight: 8,
      color: '#3295ce',
      fontSize: '12pt',
    }
  }
}
